import { NgModule } from '@angular/core';
import { ObligatoryFieldSign } from './obligatory-field-sign.component';

@NgModule({
  declarations: [ObligatoryFieldSign],
  imports: [],
  exports: [ObligatoryFieldSign],
})
export class ObligatoryFieldSignModule {}
